<template>
  <StartTimeTracker
    v-if="start"
    :isOpen="start"
    @close="$emit('update:start', false)"
  />
  <StopTimerModal
    v-if="stop"
    :isOpen="stop"
    @close="$emit('update:stop', false)"
  />
  <NotificationList
    v-if="notifications"
    :isOpen="notifications"
    @close="$emit('update:notifications', false)"
  />
</template>

<script>
import StartTimeTracker from "@/components/GlobalTimer/StartTimeTracker.vue";
import StopTimerModal from "@/components/GlobalTimer/StopTimer.vue";
import NotificationList from "@/components/Notifications/NotificationList.vue";

// Modales que abren las barras superiores (escritorio y móvil).
export default {
  components: { StartTimeTracker, StopTimerModal, NotificationList },
  props: {
    start: { type: Boolean, default: false },
    stop: { type: Boolean, default: false },
    notifications: { type: Boolean, default: false },
  },
  emits: ["update:start", "update:stop", "update:notifications"],
};
</script>
